module.exports = __webpack_public_path__ + "img/everyday_icon.680269fe.png";